import { useAuthStore } from '@/store'
import { AuthLoginState } from '@/store/auth/AuthenticationStore'
import { SubmittedLoginForm } from './SubmittedLoginForm'
import { UnsubmittedLoginForm } from './UnsubmittedLoginForm'

export enum LOGIN_STATE {
	UNSUBMITTED = 0,
	SUBMITTED = 1,
}

const LoginForm = ({ isMobile }: { isMobile: boolean }) => {
	const { loginState } = useAuthStore()

	return loginState === AuthLoginState.CODE_SENT ? (
		<SubmittedLoginForm isMobile={isMobile} />
	) : (
		<UnsubmittedLoginForm />
	)
}

export { LoginForm }
